import React, { useContext, useState, useMemo, memo } from 'react';
// import {
// 	DragDropContext,
// 	Droppable,
// 	DropResult,
// 	ResponderProvided ,
// 	DroppableProvided as droppableProvided,
// 	DraggableStateSnapshot
// } from 'react-beautiful-dnd';
import {
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Toolbar,
} from '@material-ui/core';

import MaterialTableGroupRow from './MaterialTableGropuRow';
import { useDispatch, useSelector } from "react-redux";
import AppContext from '../../../../context/Context';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

export const MaterialTableGroups = memo(({ basketMargins, totalPNL, checkedId, handleChange, isClosedPosition, basketSLTP, updateBasket, buySellClick, inputValues, info, source, items, columns, isBasketAdded, searchText, groupingMode, setGroupingMode, subGroupingMode, setSubGroupingMode }) => {
	const {
		config: { isDark },
	} = useContext(AppContext);
	const [localItems, setLocalItems] = useState(items);
	const [hoveredRowId, setHoveredRowId] = useState(null);
	const dispatch = useDispatch();
	const [expandAllTrigger, setExpandAllTrigger] = useState(0);
	const [expandAllOpen, setExpandAllOpen] = useState(false);

	const filteredItems = useMemo(() => items.map(item => {
		if (!searchText || searchText.trim() === '') {
			return item;
		}

		const searchLower = searchText.toLowerCase().trim();
		const isNumericSearch = /^\d+$/.test(searchText.trim());

		if (item && item.data) {
			const filteredData = item.data.filter(dataItem => {
				const fields = [
					dataItem.basketName || '',
					dataItem.instrument?.name || '',
					dataItem.instrument?.displayName || '',
					dataItem.instrument?.tradingSymbol || '',
					dataItem.tradingSymbol || ''
				];

				if (isNumericSearch) {
					return fields.some(field => {
						const tokens = field.split(/[\s\-_]+/);
						return tokens.some(token => token.startsWith(searchText.trim()));
					});
				} else {
					return fields.some(field => field.toLowerCase().includes(searchLower));
				}
			});

			if (filteredData.length > 0) {
				return {
					...item,
					data: filteredData
				};
			}
		}

		return null;
	}).filter(item => item !== null), [items, searchText]);

	const hasStrategies = useMemo(() => filteredItems.some(item => item.basketId && item.basketId !== "undefined"), [filteredItems]);

	const strategyHeader = (columns && columns[0] && columns[0].strategyHeader) ? columns[0].strategyHeader : [];
	const isEnabled = (key) => strategyHeader.some((c) => c.accessorKey === key && c.enableColumn);


	return (
		<>
			{hasStrategies && (
				<div className="pos-tbl-header">
					<div className='filter-icon' onClick={() => { setExpandAllOpen((prev) => { const next = !prev; setExpandAllTrigger((v) => v + 1); return next; }); }}>
						<UnfoldMoreIcon fontSize='small' />
					</div>
					<div style={{ width: "120px" }}>Symbol</div>
					{isEnabled('basketName') && (
						<div style={{ width: "184px" }}>Strategy</div>
					)}
					{isEnabled('pnl') && (
						<div style={{ width: "120px", textAlign: "right" }}>Total PNL</div>
					)}
					{isEnabled('upnl') && (
						<div style={{ width: "120px", textAlign: "right" }}>Unrealized</div>
					)}
					{isEnabled('rpnl') && (
						<div style={{ width: "120px", textAlign: "right" }}>Realized</div>
					)}
					{isEnabled('margin') && (
						<div style={{ width: "120px", textAlign: "right" }}>Margin</div>
					)}
					{isEnabled('roi') && (
						<div style={{ width: "120px", textAlign: "right" }}>ROI %</div>
					)}
					<div style={{ width: checkedId && checkedId.length > 0 ? '374px' : "286px", textAlign: "center" }}>Actions</div>
					{isEnabled('combinedPremium') && (
						<div style={{ width: "120px", marginLeft: "7px", textAlign: "right" }}>Combined Premium</div>
					)}
					<div style={{ width: "120px", textAlign: "center" }}>Risk Actions</div>
					{isEnabled('sl') && (
						<div style={{ width: "120px", textAlign: "right" }}>Stoploss</div>
					)}
					{isEnabled('ta') && (
						<div style={{ width: "120px", textAlign: "right" }}>Target</div>
					)}
					{isEnabled('trailingSL') && (
						<div style={{ width: "120px", textAlign: "right" }}>Trailing SL</div>
					)}
					<div style={{ width: "120px", textAlign: "right" }}>Profit Lock</div>
					<div style={{ width: "120px", textAlign: "right" }}>Profit Trailing</div>
				</div>
			)}
			{basketSLTP && basketSLTP.length > 0 && hasStrategies && <p className="mb-1 p-0 pos-heading">Multi Leg Strategies</p>}
			<Table className='opt-chn-tbl' >
				<TableBody>
					{filteredItems.length === 0 ? (
						<TableRow>
							<TableCell align="center" className='dataCell' colSpan={10}>
								<>{isClosedPosition ? "Positions Hidden" : searchText ? "No matching positions found" : "No Data"}</>
							</TableCell>
						</TableRow>
					) : (
						filteredItems.map((item, index) => (
							<MaterialTableGroupRow
								key={item.basketId}
								text={item?.basketId}
								index={index}
								rowData={item}
								columns={columns}
								isBasketAdded={isBasketAdded}
								source={source}
								info={info}
								inputValues={inputValues}
								buySellClick={buySellClick}
								updateBasket={updateBasket}
								isClosedPosition={isClosedPosition}
								handleChange={handleChange}
								checkedId={checkedId}
								totalPNL={totalPNL}
								hoveredRowId={hoveredRowId}
								setHoveredRowId={setHoveredRowId}
								expandAllTrigger={expandAllTrigger}
								expandAllOpen={expandAllOpen}
								groupingMode={groupingMode}
								setGroupingMode={setGroupingMode}
								subGroupingMode={subGroupingMode}
								setSubGroupingMode={setSubGroupingMode}
								basketMargins={basketMargins}
							/>
						))
					)}
				</TableBody>
			</Table>
		</>
	);
});